import * as React from "react";
function SvgIcStarFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.74 10.081l-5.784-.841L12.37 4 9.784 9.24 4 10.081l4.185 4.079-.988 5.761 5.173-2.72 5.173 2.72-.988-5.761 4.185-4.079z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcStarFilled;
